import Api from './Api';

class LogicBaseMessageApi extends Api {
  url = 'logicbasemessages';
}

const singleton = new LogicBaseMessageApi();
export default singleton;
